import PropTypes from 'prop-types';

export const stepType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.string,
  active: PropTypes.bool,
  completed: PropTypes.bool,
});
